import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { LinearProgress } from '@mui/material';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
});

export default function LinearBuffer(props) {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);

    const progressRef = React.useRef(() => { });

    useEffect(() => {
        if (props.status === 'COMPLETED') {
            setProgress(100);
            setBuffer(100);
        } else {
            progressRef.current = () => {
                if (progress > 100) {
                    setProgress(0);
                    setBuffer(10);
                } else {
                    const diff = Math.random() * 10;
                    const diff2 = Math.random() * 10;
                    setProgress(progress + diff);
                    setBuffer(progress + diff + diff2);
                }
            };
        }
    });

    useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <div className={classes.root}>
            <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
        </div>
    );
}